export default "__VITE_ASSET__CAKmDAZd__"